import React from 'react';
import { Popup } from 'semantic-ui-react';
import Selectors from '@/themes/hooks/selectors';
import MarkdownRender from './text-editors/MarkdownRender';
import TrimmedMarkdownRender from './text-editors/TrimmedMarkdownRender';

const MarkdownPopup = ({
  className,
  content,
  maxChars = 500,
  maxLines = 10,
  pinned = true,
  position = 'bottom center',
}) => {
  const { theme } = Selectors.useTheme();
  return (
    <Popup
      content={(
        <TrimmedMarkdownRender
          maxChars={maxChars}
          maxLines={maxLines}
          suffix="ellipses"
          text={content}
          withShowMore
        />
      )}
      className={`aridhia-theme-${theme}`}
      hoverable
      pinned={pinned}
      position={position}
      trigger={(<span><MarkdownRender value={content} className={className} /></span>)}
      wide
    />
  );
};

export default MarkdownPopup;
